VALIDATE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
VALIDATE_PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[0-9!@#$&*])(?=.*[a-z]).{8,}$/

class Validator
  @isEmailValid: (text='') ->
    email = text?.trim() || ''
    VALIDATE_EMAIL_REGEX.test email

  @isPasswordValid: (password = '') ->
    VALIDATE_PASSWORD_REGEX.test password

export default Validator
